<template>
    <app-modal size='xl' id='modal-import-salary-search' :show='show' @onClose='show = false'>
        <template #title>Importação massiva de pesquisa salarial</template>
        <template #body>
            <load :load="load" />
            <div class='border border-dashed rounded p-3 mb-3'>
                <div class='text-end mb-3'>
                    <app-button variant='outline-dark' icon='fa-solid fa-download' text='Baixar modelo'
                                :load='btnDownloadLoad' @click.prevent='onExportModel' />
                </div>
                <div class='form-group'>
                    <label>Arquivo <span class='text-danger'>*</span></label>
                    <input type='file' class='form-control' accept='.xls, .xlsx' @change='onFileChange($event)'
                           ref='refInputFile'>
                </div>
            </div>

            <div class='overflow-auto' style='max-height: 400px'>
                <div class='alert alert-arrow-left alert-icon-left alert-light-danger alert-dismissible mb-4'
                     role='alert' v-if='importErrors.length'>
                    <button type='button' class='close' data-bs-dismiss='alert' aria-label='Close'>×</button>
                    <font-awesome-icon icon='fa-regular fa-bell' />
                    <strong>Alerta!</strong> Erro ao importar planilha, verifique os erros e tente novamente.
                </div>

                <table class='table table-hover table-bordered' v-if='importErrors.length'>
                    <thead>
                    <tr>
                        <th>Coluna</th>
                        <th>Empresa</th>
                        <th>Cargo</th>
                        <th>Erro</th>
                        <th>Linha</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for='(importError) in importErrors'>
                        <td>{{ importError?.attribute }}</td>
                        <td>{{ importError?.values?.empresa }}</td>
                        <td>{{ importError?.values?.cargo }}</td>
                        <td>{{ importError?.errors[0] }}</td>
                        <td>{{ importError?.row }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <hr class='border'>
            <div class='d-flex justify-content-between mt-3'>
                <app-button icon='fa-solid fa-xmark' class='me-4' text='Cancelar'
                            variant='default'
                            @click='show = false' />

                <app-button icon='fa-solid fa-file-import' text='Importar' @click.prevent='onImportFile'
                            variant='success' :load='btnLoad' :disabled="!inputFile" />
            </div>
        </template>
    </app-modal>
</template>
<script setup>
    import AppModal from '@/components/AppModal.vue';
    import AppButton from '@/components/AppButton.vue';
    import Load from '@/components/Load.vue';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { computed, ref, watch } from 'vue';
    import { handleAxiosError } from '@/helpers';
    import toast from 'bootstrap/js/src/toast';
    
    const emits = defineEmits(['update:modelValue']);
    
    const props = defineProps({
        modelValue: Boolean,
    });
    
    const show = computed({
        get: () => props.modelValue,
        set: (value) => emits('update:modelValue', value),
    });
    
    const load = ref(false);
    const btnLoad = ref(false);
    const btnDownloadLoad = ref(false);
    const importErrors = ref([]);
    const inputFile = ref(null);
    const refInputFile = ref(null);
    
    const onExportModel = async () => {
        try {
            load.value = true;
            const response = await axios.get(`salary-survey/export-model`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'salary-search.xlsx';
            link.click();
        } catch (e) {
            handleAxiosError(e);
        } finally {
            load.value = false;
        }
        
    };
    
    const onImportFile = async () => {
        importErrors.value = [];
        const formData = new FormData();
        formData.append('file', inputFile.value);
        try {
            btnLoad.value = true;
            
            const { data } = await axios.post(`salary-survey/import`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            
            if (data.success) {
                show.value = false;
                Swal.fire('Sucesso', data.message, 'success');
            }
            
            inputFile.value = null;
        } catch (e) {
            if(e?.response?.status === 422) {
                importErrors.value = e.response.data.data;
            }
            handleAxiosError(e);
        } finally {
            btnLoad.value = false;
            if(refInputFile.value?.value) {
                refInputFile.value.value = null;
                inputFile.value = null;
            }
        }
    };

    const onFileChange = (event) => {
        inputFile.value = event.target.files[0];
    };
    
    watch(() => show.value, (value) => {
       if (!value) inputFile.value = null; 
    });
</script>
